import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../assets/logo.png";

const Header = () => {
  const [open, setOpen] = useState(false);

  const closeMenu = () => setOpen(false);

  return (
    <>
     <header className="header">
  <div className="container header-flex">
    <div className="logo-wrap">
      <img src={logo} alt="DSAP Solutions" />
    </div>

    {/* Desktop Navigation */}
    <nav className="nav desktop-nav">
      <Link to="/">Home</Link>
      <Link to="/services">Services</Link>
      <Link to="/contact">Contact</Link>
    </nav>

    {/* Mobile Hamburger */}
    <button
      className="hamburger"
      onClick={() => setOpen(true)}
      aria-label="Open Menu"
    >
      <span></span>
      <span></span>
      <span></span>
    </button>
  </div>
</header>


      {/* Overlay */}
      <div className={`overlay ${open ? "show" : ""}`} onClick={closeMenu}></div>

      {/* Drawer */}
      <div className={`drawer ${open ? "open" : ""}`}>
        <button className="close-btn" onClick={closeMenu}>×</button>
        <Link to="/" onClick={closeMenu}>Home</Link>
        <Link to="/services" onClick={closeMenu}>Services</Link>
        <Link to="/contact" onClick={closeMenu}>Contact</Link>
      </div>
    </>
  );
};

export default Header;
